// Типы действий для пользовательских данных
export const USER_ACTIONS = {
  SET_INTRO_COMPLETED: 'SET_INTRO_COMPLETED',
};

/**
 * Действие для установки состояния завершения вступительного слайдера
 * @param {boolean} completed - Флаг завершения просмотра слайдера
 * @returns {Object} - Объект действия Redux
 */
export const setIntroCompleted = (completed) => ({
  type: USER_ACTIONS.SET_INTRO_COMPLETED,
  payload: completed,
}); 